module.exports = __webpack_public_path__ + "img/visa.09a7a807.png";